import { z } from 'zod/v4'
import { RoleObjectValidator } from './common'

export const BaseAccountValidator = z.object({
        subscription: z.enum(['free', 'standard', 'pro']),
        name: z.string(),
        active: z.boolean(),
        locations: z.number(),
        stripeId: z.string().optional(),
        stripeLink: z.string().optional(),
        stripeCustomerPortalLink: z.string().optional(),
        roles: RoleObjectValidator,
        createdAt: z.string().optional(),
        updatedAt: z.string().optional(),
})

export const AccountValidator = BaseAccountValidator.extend({
        id: z.string(),
})

export type BaseAccount = z.infer<typeof BaseAccountValidator>
export type Account = z.infer<typeof AccountValidator>
